import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilesComponent, Notes, SimpleTabs } from 'components';
import { TimeSheetDetailHeader, TimeSheetDetailsTab } from './core';
import { timeSheetDetailTabsLabels } from './constants';
import { fileEnums, noteModels, PermissionList, RolePermission } from 'utils';
import { HistoryTab } from '../history';
import { staffPayrollActions } from 'store';
import { formModelEnums } from '../../pages';

export const TimeSheetDetail = ({}) => {
    const payrollById = useSelector((state) => state.staffPayroll.payrollById);
    const dispatch = useDispatch();

    const afterSuccess = () => {
        dispatch(staffPayrollActions.getPayrollById(payrollById?.id));
    };

    const claimTabContent = [
        {
            tabComponent: <TimeSheetDetailsTab afterSuccess={afterSuccess} />,
            tab: 'Details',
        },
        RolePermission([PermissionList.TIMESHEET_NOTE_READ?.code, PermissionList.TIMESHEET_NOTE_MANAGE?.code]) && {
            tabComponent: (
                <Notes
                    id={payrollById?.id}
                    onModel={noteModels.Timesheet}
                    formModel={formModelEnums.TIMESHEETNOTE}
                    permissions={[PermissionList.TIMESHEET_NOTE_MANAGE?.code]}
                />
            ),
            tab: 'Notes',
        },
        RolePermission([PermissionList.TIMESHEET_HISTORY_READ?.code]) && {
            tabComponent: <HistoryTab currentId={payrollById?.id} onModel={'Timesheet'} />,
            tab: 'History',
        },
        RolePermission([PermissionList.TIMESHEET_FILE_READ?.code, PermissionList.TIMESHEET_FILE_MANAGE?.code]) && {
            tabComponent: (
                <FilesComponent
                    currentId={payrollById?.id}
                    onResource={fileEnums.PAYROLL_TIMESHEET}
                    permissions={[PermissionList.TIMESHEET_FILE_MANAGE?.code]}
                />
            ),
            tab: 'Files',
        },
    ];

    return (
        <div className="tab-box-wrapper">
            <TimeSheetDetailHeader />
            <SimpleTabs defaultTab={'Details'} tabsLabels={timeSheetDetailTabsLabels} tabsContent={claimTabContent} />
        </div>
    );
};
